<script setup lang="ts">
import { ref } from 'vue';
import type { PropType } from 'vue';
import type { Tag } from '@nfc-api/tag';
import { useAppState } from '../store/state';

const props = defineProps({
  tag: {
    type: Object as PropType<Tag>,
    required: true,
  },
});

if (!props.tag) throw new Error('No tag');

const error = ref(false);

const state = useAppState();
const [linkTag, errorRes] = await state.fetchLinkTag(props.tag.uuid);

if (errorRes) {
  error.value = true;
} else {
  window.location.replace(linkTag.payload.link);
}
</script>

<template>
  <div>
    <p v-if="!error">Omdirigerar...</p>
    <p v-else>Något gick fel...</p>
  </div>
</template>
